import React from 'react';
import { Card } from 'antd';
import { SkHeader, SkStatCards, SkTabsBar, SkFilterBar, SkTable } from './_primitives';

/** MealPointsPage — header, stats, 2 tabs, search+branch filter, allowances table */
const MealPointsPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={3} />
    <SkStatCards count={4} />
    <Card className="shadow-sm">
      <SkTabsBar tabs={2} />
      <SkFilterBar filters={2} withButton />
      <div className="overflow-x-auto">
        <SkTable rows={8} cols={6} inCard={false} />
      </div>
    </Card>
  </div>
);

export default MealPointsPageLoader;
